import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/crmShipAgency/page',
    method: 'get',
    params
  })
}
export function getDateListByIdPage(params) {
  return request({
    url: '/api/business/crmShipAgency/getDateListByIdPage',
    method: 'get',
    params
  })
}
export function getShipAgencyImageList(params) {
  return request({
    url: '/api/business/crmShipAgency/getShipAgencyImageList',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/crmShipAgency/crmShipAgency',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/crmShipAgency/crmShipAgency',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/crmShipAgency/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/crmShipAgency/crmShipAgency',
    method: 'get',
    params: {
      id
    }
  })
}

export function saveIntegration(data) {
  return request({
    url: '/api/business/crmShipAgency/saveIntegration',
    method: 'post',
    data
  })
}

export function getRelevancyDataById(id) {
  return request({
    url: '/api/business/crmShipAgency/getRelevancyDataById',
    method: 'get',
    params: {
      id
    }
  })
}
export function noTagPage(params) {
  return request({
    url: '/api/business/crmShipAgency/noTagPage',
    method: 'get',
    params
  })
}

